import brazilPhoneCodes from '~constants/brazilPhoneCodes';
import { StringSchema } from 'yup';

export default function cellphone(this: StringSchema, message: string) {
  return this.test('cellphone', message, (maskedCellphone = '') => {
    if (!maskedCellphone) {
      return true;
    }
    const cellphoneWithoutMask = maskedCellphone.replace(/\D/g, '');
    const phoneCode = cellphoneWithoutMask.slice(0, 2);
    const hasCorrectNumberOfDigits =
      cellphoneWithoutMask.length === 10 || cellphoneWithoutMask.length === 11;
    const isThirdNumberEqualNine = cellphoneWithoutMask.charAt(2) === '9';
    const isValidBrazilianDDD = brazilPhoneCodes.includes(phoneCode);

    return (
      isThirdNumberEqualNine && isValidBrazilianDDD && hasCorrectNumberOfDigits
    );
  });
}
